import { render, staticRenderFns } from "./EditLiveInformationsTab.vue?vue&type=template&id=c39252e0"
import script from "./EditLiveInformationsTab.vue?vue&type=script&lang=js"
export * from "./EditLiveInformationsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports